import React from 'react';
import GenericAccordion from 'components/GenericAccordion';
import { color } from 'styles/Theme';
import { useSelector } from 'react-redux';
import LayersGroup from 'components/LayersGroup';
import * as S from './styled';

// useToggle é para decidir se o comp de carregar layer vai com toggle ou checkbox
export default function Enterprise() {
	const { allLayers } = useSelector((state) => state.allLayersMap);
	const key = 'empreendimentos';
	const filterLayers = allLayers?.filter((item) => item.key === key);

	return (
		<GenericAccordion
			title={filterLayers[0]?.name.toUpperCase() || ''}
			keyAccordion={key}
			styleTitle={{
				color: `${color.interface.darkGray}`,
				fontFamily: 'Nunito',
				fontStyle: 'normal',
				fontWeight: '800',
				lineHeight: '0.875rem',
				fontSize: '0.625rem',
				letterSpacing: '0.1em',
				textTransform: 'uppercase'
			}}
		>
			<S.containerAccordionInside>
				<LayersGroup layerGroup={key} useToggle={false} showTitle={false} />
			</S.containerAccordionInside>
		</GenericAccordion>
	);
}
